var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.99561H23V23.9956H1V1.99561Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0722 16.9912V22.062L4.01904 22.062",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86279 22.1465V6.74053L7.96373 2.64002H18.0726L18.0726 6.99121",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86279 6.74072L7.96373 2.64021V6.74072H3.86279Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8337 15.9912H10.2454C9.85559 15.9912 9.53955 15.5939 9.53955 15.1036V7.87883C9.53955 7.38862 9.85559 6.99121 10.2454 6.99121H21.8337C22.2236 6.99121 22.5396 7.38862 22.5396 7.87883V15.1036C22.5396 15.5939 22.2236 15.9912 21.8337 15.9912Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6744 13.032C12.248 13.032 11.8979 12.9315 11.624 12.7304C11.3501 12.5259 11.2028 12.2347 11.182 11.8568H12.2688C12.2792 11.9851 12.3173 12.0787 12.3832 12.1376C12.4491 12.1965 12.534 12.226 12.638 12.226C12.7316 12.226 12.8079 12.2035 12.8668 12.1584C12.9292 12.1099 12.9604 12.044 12.9604 11.9608C12.9604 11.8533 12.9101 11.7701 12.8096 11.7112C12.7091 11.6523 12.5461 11.5864 12.3208 11.5136C12.0816 11.4339 11.8875 11.3576 11.7384 11.2848C11.5928 11.2085 11.4645 11.0993 11.3536 10.9572C11.2461 10.8116 11.1924 10.6227 11.1924 10.3904C11.1924 10.1547 11.2513 9.95361 11.3692 9.78721C11.4871 9.61734 11.65 9.48907 11.858 9.40241C12.066 9.31574 12.3017 9.27241 12.5652 9.27241C12.9916 9.27241 13.3313 9.37294 13.5844 9.57401C13.8409 9.77161 13.9779 10.0507 13.9952 10.4112H12.8876C12.8841 10.3003 12.8495 10.2171 12.7836 10.1616C12.7212 10.1061 12.6397 10.0784 12.5392 10.0784C12.4629 10.0784 12.4005 10.1009 12.352 10.146C12.3035 10.1911 12.2792 10.2552 12.2792 10.3384C12.2792 10.4077 12.3052 10.4684 12.3572 10.5204C12.4127 10.5689 12.4803 10.6123 12.56 10.6504C12.6397 10.6851 12.7576 10.7301 12.9136 10.7856C13.1459 10.8653 13.3365 10.9451 13.4856 11.0248C13.6381 11.1011 13.7681 11.2103 13.8756 11.3524C13.9865 11.4911 14.042 11.6679 14.042 11.8828C14.042 12.1012 13.9865 12.2971 13.8756 12.4704C13.7681 12.6437 13.6104 12.7807 13.4024 12.8812C13.1979 12.9817 12.9552 13.032 12.6744 13.032ZM17.433 9.32961V10.1408H16.4554V12.9956H15.4362V10.1408H14.469V9.32961H17.433ZM19.8225 12.9956L19.0945 11.6436H18.9853V12.9956H17.9661V9.32961H19.5729C19.8676 9.32961 20.1172 9.38161 20.3217 9.48561C20.5262 9.58614 20.6805 9.72654 20.7845 9.90681C20.8885 10.0836 20.9405 10.2829 20.9405 10.5048C20.9405 10.7544 20.8712 10.9745 20.7325 11.1652C20.5973 11.3524 20.398 11.4859 20.1345 11.5656L20.9613 12.9956H19.8225ZM18.9853 10.9468H19.4897C19.6284 10.9468 19.7324 10.9139 19.8017 10.848C19.871 10.7821 19.9057 10.6868 19.9057 10.562C19.9057 10.4441 19.8693 10.3523 19.7965 10.2864C19.7272 10.2171 19.6249 10.1824 19.4897 10.1824H18.9853V10.9468Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPdf);
export default __webpack_public_path__ + "static/media/footerPdf.d5dc0a5820319c898904b4cc9d181f7e.svg";
export { ForwardRef as ReactComponent };